import { EntityType } from '@shared/models/entity-enum';
import { sanitizeValue } from '@shared/pipe/data-cell-formatter.pipe';

export interface KpisResult {
  total_area_leased: number;
  average_area_leased: number;
  average_lease_term: number;
  weighted_average_base_rent_monthly: number;
  weighted_average_base_rent_yearly: number;
  total_space_area?: number;
}

export const DEFAULT_KPIS_RESULT: KpisResult = {
  total_area_leased: null,
  average_area_leased: null,
  average_lease_term: null,
  weighted_average_base_rent_monthly: null,
  weighted_average_base_rent_yearly: null,
  total_space_area: null,
};

export const ADDITIONAL_KPI_COLUMNS_SPACES_VIEW = [
  {
    columnId: 999874,
    header: 'Total Space Area',
    displayFn: value => {
      const sanitizedValue = sanitizeValue(
        value.total_space_area,
        { dataType: 'numeric', options: { format: '.0-0' } },
        '-'
      );
      return `${sanitizedValue} SF`;
    },
  },
];

export const KPI_SUMMARY_COLUMNS = {
  [EntityType.LeaseComp]: [
    {
      columnId: 999870,
      header: 'Total Area Leased',
      displayFn: value => {
        const sanitizedValue = sanitizeValue(
          value.total_area_leased,
          { dataType: 'numeric', options: { format: '.0-0' } },
          '-'
        );
        return `${sanitizedValue} SF`;
      },
    },
    {
      columnId: 999871,
      header: 'Avg Area Leased',
      displayFn: value => {
        const sanitizedValue = sanitizeValue(
          value.average_area_leased,
          { dataType: 'numeric', options: { format: '.0-0' } },
          '-'
        );
        return `${sanitizedValue} SF`;
      },
    },
    {
      columnId: 999872,
      header: 'Avg Term',
      displayFn: value => {
        const sanitizedValue = sanitizeValue(
          value.average_lease_term,
          { dataType: 'numeric', options: { format: '.0-0' } },
          '-'
        );
        return `${sanitizedValue} Mths`;
      },
    },
    {
      columnId: 999873,
      header: 'Avg Base Rent',
      displayFn: value => {
        const sanitizedMonthly = sanitizeValue(
          value.weighted_average_base_rent_monthly,
          { dataType: 'numeric', options: { format: '.2-2' } },
          '-'
        );
        const sanitizedYearly = sanitizeValue(
          value.weighted_average_base_rent_yearly,
          { dataType: 'numeric', options: { format: '.2-2' } },
          '-'
        );
        return `$ ${sanitizedMonthly} Mthly/$ ${sanitizedYearly} Yrly`;
      },
    },
  ],
};
